import { defineStore } from 'pinia'
import {
  fetchPreview,
  fetchUnreadCount,
  markAllNotificationsAsRead,
  markNotificationAsRead,
} from '@/modules/notifications/services/notifications.service'

export const useNotificationsStore = defineStore('notifications::store', {
  state: () => ({
    unreadCount: 0,
    preview: [],
    isLoadingPreview: false,
    hasError: false,
  }),

  getters: {
    hasUnread: state => state.unreadCount > 0,
  },

  actions: {
    async loadUnreadCount() {
      try {
        const { count } = await fetchUnreadCount()
        this.unreadCount = count || 0
      }
      catch {
        this.unreadCount = 0
      }
    },

    async loadPreview() {
      this.isLoadingPreview = true
      this.hasError = false

      try {
        this.preview = await fetchPreview() || []
      }
      catch {
        this.preview = []
        this.hasError = true
      }
      finally {
        this.isLoadingPreview = false
      }
    },

    async refresh() {
      await Promise.all([this.loadUnreadCount(), this.loadPreview()])
    },

    async markAsRead(id) {
      await markNotificationAsRead(id)

      this.preview = this.preview.filter(notification => notification._id !== id)
      this.unreadCount = Math.max(this.unreadCount - 1, 0)

      this.refresh()
    },

    async markAllAsRead() {
      await markAllNotificationsAsRead()

      this.preview = []
      this.unreadCount = 0
    },
  },
})
